import React from 'react'
import { Alertbox, ErrorLink } from '@olxbr/ds-web'
import { AlertTriangle } from '@olxbr/olx-icons/dist/System'
import { faleConosco } from '../../../settings/staticUrl'

import PropTypes from 'prop-types'
import styled from 'styled-components'

export const ErrorAlertbox = ({
  title,
  customIcon,
  children,
  showContactUs = true,
  customLink,
}) => {
  const Container = styled.div`
    margin-bottom: var(--spacing-3);
  `

  const renderLink = (href, text) => {
    return (
      <div>
        <div className="flex mt-0-5">
          {customLink ? (
            <ErrorLink href={href}>{text}</ErrorLink>
          ) : (
            <span>
              Em caso de dúvidas,&nbsp;<ErrorLink href={href}>{text}</ErrorLink>
            </span>
          )}
        </div>
      </div>
    )
  }

  return (
    <Container>
      <Alertbox
        icon={customIcon ? customIcon : <AlertTriangle />}
        flex="1"
        title={title}
        variant="error"
      >
        <span className="typo-body-medium">{children}</span>

        {showContactUs && renderLink(faleConosco, 'fale com a gente.')}

        {customLink && renderLink(customLink.href, customLink.text)}
      </Alertbox>
    </Container>
  )
}

ErrorAlertbox.propTypes = {
  title: PropTypes.string,
  customIcon: PropTypes.element,
  showContactUs: PropTypes.bool,
  customLink: PropTypes.exact({
    text: PropTypes.string,
    href: PropTypes.string,
  }),
}
